/* @flow */

import * as React from 'react'

import CloudinaryResource from '../../../infrastructure/components/CloudinaryResource'
import { createWebshopProductImageTransformations } from './shared'

import { WebshopContext } from '../shared'

const WebshopProductImage = ({ ...props }) => {
  const { brand, webshopDesignSettings } = React.useContext(WebshopContext)

  const transformations = React.useMemo(() => {
    const transformations = createWebshopProductImageTransformations(
      webshopDesignSettings
    )

    return transformations
  }, [webshopDesignSettings])

  return (
    <CloudinaryResource
      brandId={brand.id}
      transformations={transformations}
      {...props}
    />
  )
}

export default WebshopProductImage
